module.exports = __webpack_public_path__ + "assets/img/sidemenu-item04.04c5d092.svg";